import NormalBtn from '../StockItems/NormalBtn';
import {useState, useEffect} from 'react';
import * as ServerComms from '../utilities/ServerComms';
import * as SharedAcross from '../utilities/SharedAcross';
import TableWrapRowsBoot from '../StockItems/TableWrapRowsBoot';
import DropdownMenu from '../StockItems/DropdownMenu';

function App(props) {

  var width = props.width;
  var logInState = props.logInState;
  var addToExtraScreen = props.addToExtraScreen;

  var sessionID = props.sessionID;
  var userID = props.userID;
  var signKey = props.signKey;
  var programSetID = props.programSetID;
  var setAccessLevel = props.setAccessLevel;


  const [programUsers, setProgramUsers] = useState([]);
  const [newText, setNewText] = useState('');
  const [isAdding, setIsAdding] = useState(false);
  const [isAddingAddress, setIsAddingAddress] = useState(1);

  function changeText(e){
    setNewText(e.target.value);
  }

  function saveProgramUsers(response){
    setProgramUsers(response.v);
    for (var i = 0; i < response.v.length; i++){
      var thisResponse = response.v[i];
      if (thisResponse.v[1].v === userID){
        setAccessLevel(thisResponse.v[4].v);
      }
    }

    setIsAdding(false);
  }

  function clickSubmit(){
    var addressToAdd = newText.trim();
    if (isAddingAddress){
      if (!SharedAcross.isEthAddress (addressToAdd)){
        window.alert('Invalid Address (Addresses are of the form 0x1234567890123456789012345678901234567890)');
        return;
      }
    }else{
      if (!addressToAdd){
        window.alert('Invalid Email addess');
        return;
      }
    }

    if (!isAdding){
      setIsAdding({t:'add'});
      ServerComms.fetchSomething({u:'addAddressToProgram', isAddingAddress, addressToAdd, programSetID, sessionID, signKey, userID}, saveProgramUsers);
      setNewText('');
    }
  }

  function onKeyDown(e){
    if (e.keyCode === 13){
      clickSubmit();
    }
  }

  function getProgramUsers(){
    ServerComms.fetchSomething({u:'getProgramUsers', programSetID, sessionID, signKey, userID}, saveProgramUsers);
  }

  useEffect(()=>{
    getProgramUsers();    
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  if (!logInState){

    function clickSignIn(e){
      addToExtraScreen({t:'signIn'});
    }

    return <div style={{padding:'10px', width}}>
            <b>Please sign in first before sharing your work</b><br/><br/>
            <NormalBtn title='Connect' onClick={clickSignIn} />
      </div>
  }

//
  // function deleteAccess(programUserId){
  //   return function(e){
  //     if (!isAdding){
  //       setIsAdding({t:'delete', v:programUserId});
  //       ServerComms.fetchSomething({u:'deleteProgramAccess', programUserId, programSetID, sessionID, signKey, userID}, saveProgramUsers);

  //     }
  //   }
  // }

  // function adminAccess(programUserId, newAdmin){
  //   return function(e){
  //     if (!isAdding){
  //       setIsAdding({t:'admin', v:programUserId});
  //       ServerComms.fetchSomething({u:'adminProgramAccess', programUserId, newAdmin, programSetID, sessionID, signKey, userID}, saveProgramUsers);
  //     }
  //   }
  // }

  var isAdmin = false;
  for (var i = 0; i < programUsers.length; i++){
    if (programUsers[i].v[1].v === userID){
      isAdmin = (programUsers[i].v[4].v === 10);
      break;
    }
  }

  var statuses = [{i:1, n:'View', a:'carbon:view'}, {i:3, n:'Edit', a:'akar-icons:edit'}, {i:5, n:'Edit + Launch', a:'ph:rocket-launch'}, {i:10, n:'Admin', a:'subway:admin-1'}, {i:-1, n:'Remove Access', a:'fe:trash'}];

  function getStatusName(status){
    for (var i = 0; i < statuses.length; i++){
      if (statuses[i].i === status){
        return statuses[i].n;
      }
    }
  }

  function clickDirect(programUserId){
    return function(newState){
      if (!isAdding){
        for (var i = 0; i < programUsers.length; i++){
          if (programUsers[i].v[0].v === programUserId){
            if (programUsers[i].v[1].v === userID){
              if (newState === -1){
                var p = window.confirm('Are you sure that you want to remove your own access to this dApp?');
                if (!p){
                  return;
                }
              }else{
                var oldState = programUsers[i].v[4].v;
                if (oldState === newState){
                  return;
                }
                var p1 = window.confirm('Are you sure that you want to degrade your own access level for this dApp?');
                if (!p1){
                  return;
                }

              }
            }
          }
        }
        
        setIsAdding({t:'admin', v:programUserId});
        if (newState === -1){
          ServerComms.fetchSomething({u:'deleteProgramAccess', programUserId, programSetID, sessionID, signKey, userID}, saveProgramUsers);
        }else{
          ServerComms.fetchSomething({u:'adminProgramAccess', programUserId, newAdmin:newState, programSetID, sessionID, signKey, userID}, saveProgramUsers);
          // ServerComms.fetchSomething({u:'adminContractAccess', contractUserId, newAdmin:newState, contractSetID, sessionID, signKey, userID}, saveContractUsers);
        }

      }
      // console.log(newState);
    }
  }

  
  var rows = programUsers.map((aProgramUser, index)=>{

      var ownerBit = '';
      var statusBit;
      if (aProgramUser.v[1].v === userID){
        ownerBit = ' [You]';
      }

      if (isAdding && isAdding.t === 'admin' && isAdding.v === aProgramUser.v[0].v){
        statusBit = 'Updating...';
      }else if (isAdmin){
        statusBit = <DropdownMenu clickItemInSelect={clickDirect(aProgramUser.v[0].v)} options={statuses} currentAnswer={aProgramUser.v[4].v}/>
      }else if (aProgramUser.v[1].v === userID){
        var filteredStatus = statuses.filter((aStatus, index)=>{
          return aStatus.i <= aProgramUser.v[4].v;
        })
        statusBit = <DropdownMenu clickItemInSelect={clickDirect(aProgramUser.v[0].v)} options={filteredStatus} currentAnswer={aProgramUser.v[4].v}/>
      }else{
        statusBit = getStatusName(aProgramUser.v[4].v);
      }

      var addressOrEmail = ''
      if (aProgramUser.v[2].v){
        addressOrEmail = aProgramUser.v[2].v;
      }else{
        addressOrEmail = aProgramUser.v[3].v;
      }

      return <tr key={index} className='table-secondary'>
              <td style={{width:'50%'}}>{addressOrEmail + ownerBit}</td>
              <td style={{width:'50%'}}>{statusBit}</td>
            </tr>
//
  })
//

  if (isAdmin){

    var submitLine;
    if (isAdding && isAdding.t === 'add'){
      submitLine = <div>Adding...</div>
  //
    }else{
      submitLine = <NormalBtn title='Submit' onClick={clickSubmit} />
    }


    function changeIsAddingAddress(x){
      return function(e){
        setNewText('');
        setIsAddingAddress(x);
      }
    }

    var placeholder = 'Wallet address (e.g. 0x1234567890123456789012345678901234567890)';
    if (!isAddingAddress){
      placeholder = 'Email address';
    }

    rows.push(<tr><td colSpan='4'>
        <center>
        <br/>
        <NormalBtn title='Add Wallet Address' onClick={changeIsAddingAddress(1)} oppositeColor={isAddingAddress} />
        <NormalBtn title='Add Email' onClick={changeIsAddingAddress(0)}  oppositeColor={1 - isAddingAddress}/>
        <br/><br/>
        <input value={newText} placeholder={placeholder} required className="form-control" onKeyDown={onKeyDown} onChange={changeText}></input>
        <br/>
        {submitLine}
        </center>
        </td></tr>)

  }
//

  return <div style={{padding:'10px', width}}>
      <TableWrapRowsBoot rows={rows} headerCells={['Addresses with Edit Rights', '']} />
      <p className="mb-0">* Only Admins are allowed to add new users, as well as confer and remove admin status</p>
    </div>

}

export default App;
